var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.875 20.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .icon-plus-style {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-plus-style",
    d: "M11,.563A10.438,10.438,0,1,0,21.438,11,10.436,10.436,0,0,0,11,.563Zm6.06,11.616a.507.507,0,0,1-.505.505H12.683v3.872a.507.507,0,0,1-.505.505H9.822a.507.507,0,0,1-.505-.505V12.683H5.445a.507.507,0,0,1-.505-.505V9.822a.507.507,0,0,1,.505-.505H9.317V5.445a.507.507,0,0,1,.505-.505h2.357a.507.507,0,0,1,.505.505V9.317h3.872a.507.507,0,0,1,.505.505Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.37270884f07314c1efc8a5a3562b7c02.svg";
export { ForwardRef as ReactComponent };